import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, manageActions, authActions } from '../../../store/actions'
import moment from 'moment'
import history from '../../../route/history'

export const InviteUseTab1 = (props) => {
  const [state, setState] = useState({
    notUser: false,
    managerInfo: null,
    userList: [],
    selectUser: null,
  })

  useEffect(() => {
    // 법인관리회원이 아닐 때 메인화면으로 이동
    console.log('roleDto', props.auth.user.payload.roleDto)
    if (props.auth.user.payload.roleDto?.roleId !== 1) {
      props.success({
        title: '실패',
        message: '법인관리회원만 사용 가능한 메뉴입니다. \n 메인화면으로 이동합니다.',
        params: {
          type: 'ERROR',
          callback: () => {
            history.replace('/')
          },
        },
      })
    }
  }, [props.auth.user.payload.roleDto?.roleId])

  useEffect(() => {
    // 위임 회원 조회     - /user/auth-member
    props.checkDelegate()
    // 위임대상 회원 조회 - /user/auth-list
    props.getUserList()
  }, [])

  /** 위임중 이용자 정보 조회 **/
  useEffect(() => {
    if (props.managerInfo?.authId) {
      setState({ ...state, managerInfo: props.managerInfo, selectUser: props.managerInfo.authId })
    }
  }, [props.managerInfo])

  /** 위임 가능한 사용자 정보 조회 **/
  useEffect(() => {
    if (props.delegateList != null) {
      props.delegateList?.length > 0
        ? setState({ ...state, notUser: false, userList: props.delegateList })
        : setState({ ...state, notUser: true })
    }
  }, [props.delegateList])

  useEffect(() => {
    props.isDelegate === true &&
      props.success({
        title: '권한위임완료',
        message: '권한위임이 완료됩니다.',
        params: {
          type: 'SUCCESS',
          action: 'authActions',
          method: 'logOut',
          params: '/loginIntro',
        },
      })
  }, [props.isDelegate])

  /** 사용자 위임 **/
  const changeManager = () => {
    if (state.selectUser == null || state.selectUser.length <= 0) {
      props.error({ message: '위임할 이용자를 선택해주세요.' })
      return
    }

    props.delegateManager(state.selectUser)
  }

  const handleChange = (e) => {
    const { value } = e.target

    setState({
      ...state,
      selectUser: value,
    })
  }

  function InviteUserBox({ user }) {
    return (
      <tr>
        <td>
          <input
            type="radio"
            id={user.memberId}
            name={user.memberId}
            value={user.memberId}
            checked={state.selectUser === user.memberId}
            onChange={handleChange}
          />
          <em />
        </td>
        <td>{user.memberName}</td>
        <td>{user.memberId}</td>
        <td>{user.userSeCdName}</td>
        <td>{user.regDt == '' ? '' : moment(user.regDt).format('YYYY.MM.DD hh:mm')}</td>
      </tr>
    )
  }

  return (
    <div id="use-tab1" className="tab-cont">
      <div className="list-header">
        <span className="total-num">
          전체 <em>{state.selectUser ? '1' : '0'}</em>건 선택
        </span>
      </div>
      <div className="tbl-wrap">
        <table className="tbl-list">
          <caption>선택, 이름, ID, 사용자구분, 가입일시 항목으로 구성</caption>
          <colgroup>
            <col style={{ width: '6%' }} />
            <col style={{ width: '12%' }} />
            <col style={{ width: '18%' }} />
            <col style={{ width: '22%' }} />
            <col style={{ width: '22%' }} />
          </colgroup>
          <thead>
            <tr>
              <th scope="col">선택</th>
              <th scope="col">이름</th>
              <th scope="col">ID</th>
              <th scope="col">사용자구분</th>
              <th scope="col">가입일시</th>
            </tr>
          </thead>
          <tbody>
            {state?.userList?.length > 0 ? (
              state.userList.map((user, index) => <InviteUserBox user={user} key={user?.memberId ? user?.memberId : index} />)
            ) : (
              <tr>
                <td className="center" colSpan={5}>
                  <div className="nodata">조회 결과가 없습니다.</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="btn-block center">
        <a className="btn-primary lg w200 cursor" onClick={changeManager}>
          권한위임
        </a>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  managerInfo: state.manage.managerInfo,
  delegateList: state.manage.delegateList,
  isDelegate: state.manage.isDelegate,
})

const mapDispatchToProps = {
  resetDelegate: manageActions.resetDelegate,
  checkDelegate: manageActions.checkDelegate,
  getUserList: manageActions.getDelegateUserList,
  delegateManager: manageActions.createDelegateManager,
  error: alertActions.error,
  success: alertActions.success,
}

export default connect(mapStateToProps, mapDispatchToProps)(InviteUseTab1)
